import { render, staticRenderFns } from "./CreateAdvertisement.vue?vue&type=template&id=ed84e1e2&scoped=true&"
import script from "./CreateAdvertisement.vue?vue&type=script&lang=js&"
export * from "./CreateAdvertisement.vue?vue&type=script&lang=js&"
import style0 from "./CreateAdvertisement.vue?vue&type=style&index=0&id=ed84e1e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed84e1e2",
  null
  
)

export default component.exports